export const TABLE = {
  // Room
  MEETTING_ROOM: {
    TH: 'พื้นที่จัดประชุม',
    EN: 'Meeting Spaces'
  },
  ROOM_DETAIL: {
    TH: 'รายละเอียดพื้นที่',
    EN: 'Space Detail'
  },
  TIME: {
    TH: 'เวลา',
    EN: 'Time'
  },
  MEETTING_NAME: {
    TH: 'หัวข้อการประชุม',
    EN: 'Meeting name'
  },
  STATUS: {
    TH: 'สถานะ',
    EN: 'Status'
  },
  FACILITY: {
    TH: 'สิ่งอำนวยความสะดวก',
    EN: 'Facility'
  },
  ROOM_MANUAL: {
    TH: 'คู่มือการใช้งานห้องประชุม',
    EN: 'Room Manual:'
  },
  TIME_SLOT: {
    TH: 'ตารางเวลา',
    EN: 'Time Slot'
  }
}

export const ROOM_TEXT = {
  GALLARY: {
    TH: 'รูปภาพ',
    EN: 'Gallery'
  },
  NO_GALLARY: {
    TH: 'ไม่มีรูปภาพ',
    EN: 'No Image'
  },
  NO_FACILITY: {
    TH: 'ไม่มี',
    EN: 'Don\'t have list data facility.'
  },
  NO_ROOM_MANUAL: {
    TH: 'ไม่มี',
    EN: 'Don\'t have a room manual link.'
  },
  NO_DATA: {
    TH: 'ไม่มีการจองในขณะนี้',
    EN: 'No bookings found. Create a booking to get started.'
  },
  BOOK_NOW: {
    TH: 'จองเลย',
    EN: 'Book now'
  },
  STATUS: {
    BUSY: {
      TH: 'ไม่ว่าง',
      EN: 'Busy'
    },
    WAITING: {
      TH: 'รอใช้งาน',
      EN: 'Waiting'
    },
    AVAILABLE: {
      TH: 'ว่าง',
      EN: 'Available'
    }
  },
  MEMBER: {
    TH: 'คน',
    EN: 'persons'
  },
  PERSON: {
    TH: 'คน',
    EN: 'person'
  },
  CLOSE: {
    TH: 'ปิด',
    EN: 'Close'
  },
  FLOOR: {
    TH: 'ชั้น',
    EN: 'Floor'
  },
}

export const MAXIMUM_NUMBER_OF_USERS = {
  TH: 'จำนวนผู้ใช้งานสูงสุด',
  EN: 'Maximum number of users',
}
